// 我的需求单 dlg 组件

const myDemandDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

  },

  getters: {
    dlgShow: state => state.dlgShow,

  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

  },

  actions: {

  }
}

export default myDemandDlg
